<template>
  <LayoutContainer id="page-resources" class="mt-12">
    <h1 class="mb-5 text-center text-lg font-bold uppercase tracking-wide">
      Resources
    </h1>

    <main>
      <form
        v-if="!success"
        :class="{ 'pointer-events-none opacity-60': submitting }"
        class="grid grid-cols-4 items-center gap-4 rounded-lg border border-black p-4 text-sm"
        @submit.prevent="onSubmit()"
      >
        <label class="font-bold" for="resource-type">Choose Resource</label>
        <div class="col-span-3">
          <select
            class="form-select rounded border border-gray-400 text-sm focus:border-transparent focus:ring-black"
            name="resource-type"
            id="resource-type"
            v-model="resourceType"
            required
          >
            <option value="">Choose a resource</option>
            <option
              v-for="{ slug, title, _id } in resources"
              :value="slug.current"
              :key="`resource.dropdown.${_id}`"
            >
              {{ title }}
            </option>
          </select>
        </div>

        <label class="font-bold" for="join-newsletter">Join Newsletter</label>
        <div class="col-span-3 flex items-center">
          <input
            class="form-checkbox border border-gray-400 text-black focus:ring-black"
            type="checkbox"
            id="join-newsletter"
            name="join-newsletter"
            v-model="joinNewsletter"
          />
        </div>

        <label class="font-bold" for="input-email">Enter your email</label>
        <div class="col-span-3">
          <input
            class="form-input w-full rounded border border-gray-400 text-sm focus:border-transparent focus:ring-black"
            type="email"
            id="input-email"
            name="input-email"
            required
            v-model="email"
          />
        </div>

        <div class="col-span-full mt-4">
          <button
            class="w-full rounded bg-black px-4 py-2 text-white hover:bg-gray-800"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
      <div v-else class="text-center">
        Thank you for your submission! Please check your email for further
        instructions.
      </div>
    </main>
  </LayoutContainer>
</template>

<script setup lang="ts">
import type { Resources } from "~/@types/schema"
import { getAll } from "~/groq/resources"

const email = ref("")
const resourceType = ref("")
const joinNewsletter = ref(true)
const submitting = ref(false)
const success = ref(false)

const route = useRoute()

resourceType.value = (route.query.id as string) || ""

const { data: resources } = await useSanityQuery<Resources[]>(getAll())

const selectedResource = computed(() => {
  return (
    resources.value?.find(
      (resource) => resource.slug.current === resourceType.value,
    ) || null
  )
})

const onSubmit = async () => {
  submitting.value = true

  if (!selectedResource.value) {
    alert("Please select a valid resource.")
    submitting.value = false
    return
  }

  await $fetch("/api/resources", {
    method: "POST",
    body: {
      email: email.value,
      resourceType: resourceType.value,
      resourceTitle:
        selectedResource.value?.altTitle || selectedResource.value?.title,
      joinNewsletter: joinNewsletter.value,
    },
  })
    .then(() => {
      success.value = true
    })
    .catch((error) => {
      alert(
        `There was an error submitting the form: ${
          error.data?.message || error.message
        }`,
      )
    })
    .finally(() => {
      submitting.value = false
    })
}
</script>
